/**
 * IANA timezone options for the Settings picker.
 *
 * `Intl.supportedValuesOf('timeZone')` gives the full list in every browser this app targets; the
 * short fallback exists only so the control still works in an engine that lacks it (the browser's
 * own zone is always present either way).
 */

const FALLBACK_ZONES = [
  'UTC',
  'Europe/London',
  'Europe/Dublin',
  'Europe/Lisbon',
  'Europe/Madrid',
  'Europe/Paris',
  'Europe/Berlin',
  'Europe/Amsterdam',
  'Europe/Brussels',
  'Europe/Zurich',
  'Europe/Rome',
  'Europe/Prague',
  'Europe/Warsaw',
  'Europe/Vilnius',
  'Europe/Riga',
  'Europe/Tallinn',
  'Europe/Helsinki',
  'Europe/Stockholm',
  'Europe/Oslo',
  'Europe/Copenhagen',
  'Europe/Athens',
  'Europe/Bucharest',
  'Europe/Kyiv',
  'Europe/Istanbul',
  'Europe/Moscow',
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Phoenix',
  'America/Los_Angeles',
  'America/Anchorage',
  'America/Toronto',
  'America/Vancouver',
  'America/Mexico_City',
  'America/Bogota',
  'America/Lima',
  'America/Sao_Paulo',
  'America/Argentina/Buenos_Aires',
  'Africa/Casablanca',
  'Africa/Lagos',
  'Africa/Cairo',
  'Africa/Johannesburg',
  'Africa/Nairobi',
  'Asia/Jerusalem',
  'Asia/Dubai',
  'Asia/Karachi',
  'Asia/Kolkata',
  'Asia/Dhaka',
  'Asia/Bangkok',
  'Asia/Jakarta',
  'Asia/Singapore',
  'Asia/Hong_Kong',
  'Asia/Shanghai',
  'Asia/Seoul',
  'Asia/Tokyo',
  'Australia/Perth',
  'Australia/Adelaide',
  'Australia/Brisbane',
  'Australia/Sydney',
  'Pacific/Auckland',
] as const;

type SupportedValuesOf = (key: 'timeZone') => string[];

export function timezoneOptions(current: string | null, browserZone: string): string[] {
  let zones: string[] = [];
  const supported = (Intl as unknown as { supportedValuesOf?: SupportedValuesOf }).supportedValuesOf;
  if (typeof supported === 'function') {
    try {
      zones = supported('timeZone');
    } catch {
      zones = [];
    }
  }
  if (zones.length === 0) zones = [...FALLBACK_ZONES];

  const all = new Set(zones);
  all.add('UTC');
  all.add(browserZone);
  if (current !== null && current.length > 0) all.add(current);
  return [...all].sort((a, b) => a.localeCompare(b));
}
